module.exports = __webpack_public_path__ + "static/media/single-right-blue.17d6ce85.svg";